<template>
  <div v-if="$root.cache.me.department == 'risk'">
    <VDropdown>
      <div title="Platformdan para çek" class="global-button-xs cursor-pointer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4 text-tile-400"
          viewBox="0 0 32 32"
        >
          <circle cx="19" cy="27" r="1" fill="currentColor" />
          <path
            fill="currentColor"
            d="M29 31H16c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h13c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2m-13-6v4h13v-4zm13-4H16c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h13c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2m-13-6v4h13v-4z"
          />
          <path
            fill="currentColor"
            d="M12 27.3C7.347 25.648 4 21.213 4 16C4 9.383 9.383 4 16 4c4.831 0 8.994 2.876 10.895 7h2.166C27.042 5.746 21.957 2 16 2C8.28 2 2 8.28 2 16c0 6.33 4.225 11.685 10 13.41z"
          />
        </svg>
        <span class="text-tile-400">(MT5) Para çek</span>
      </div>
      <template #popper>
        <form
          class="p-2 flex items-center space-x-2"
          @submit.prevent="createWithdrawal()"
        >
          <label>Tutar</label>
          <input type="text" v-model="form.amount" class="uk-input" />
          <savebutton title="Çek" />
        </form>
      </template>
    </VDropdown>
  </div>
</template>
<script>
import EventBus from "../../../../components/Ui/EventBus";
import http from "../../../../services/http";

import { hideAllPoppers } from "floating-vue";
export default {
  props: ["login", "type"],
  methods: {
    createWithdrawal() {
      http.mt5
        .createWithdrawal({
          type: this.type,
          login: this.login,
          amount: this.form.amount,
          leverage: this.form.leverage,
        })
        .then((resp) => {
          if (resp.data.success) {
            hideAllPoppers();
            EventBus.$emit("bottomMessage", {
              open: true,
              type: "success",
              title: "Başarılı",
              duration: 2000,
              body:
                "Başarılı bir şekilde çekim yaptınız, çekim miktarı (" +
                this.form.amount +
                ")",
            });
          } else {
            EventBus.$emit("bottomMessage", {
              open: true,
              duration: 2000,
              type: "error",
              title: "Hata",
              body:
                "Çekim yapılırken hata oluştu girdiğiniz bilgileri kontrol ediniz" +
                JSON.stringify(this.form),
            });
          }
        })
        .catch(() => {
          EventBus.$emit("bottomMessage", {
            open: true,
            duration: 2000,
            type: "error",
            title: "Hata",
            body:
              "Çekim yapılırken hata oluştu girdiğiniz bilgileri kontrol ediniz" +
              JSON.stringify(this.form),
          });
        });
    },
  },
  data() {
    return {
      form: {
        amount: null,
        leverage: 100,
      },
    };
  },
};
</script>
